// login modal
export default function(){
	(function($) {

		var fromTop;
		function login_modal_open(){

			fromTop = $(window).scrollTop();
			$("html").css({
				top: -fromTop,
			});

			// Add body class
			$('html').addClass('has-modal has-modal--login');

		}

		function login_modal_close(){
			$('html').removeClass('has-modal has-modal--login');
			$(window).scrollTop(fromTop);
		}

		function login_modal_init(){

			$('.body-content, .login-modal__close').click(function(e){
				if($('html').hasClass('has-modal--login')){
					login_modal_close();
				}
			});
		}

		function login_modal_username(username){
			$('.login-modal input[name="username"]').val(username);
		}

		login_modal_init();
		$('body').on('click', '.open-login-modal, .open-login-modal a', function(e){

			if($('.login-modal').length == 0){
				return;
			}

			e.preventDefault();
			let $target = $(e.currentTarget);
			let username = $target.data('username');
			if(username){
				login_modal_username(username);

                // If the username is pre-filled, add "active" class to show the input label at the top
                $('.login-modal input[name="username"]').parent(".form-row").addClass("active");
			}

			setTimeout( login_modal_open , 0 );

		});

		function ajax_login(){

			// Perform AJAX login on form submit
			$('form.ajaxlogin').on('submit', function(e){
				e.preventDefault();
                let $status = $('form.ajaxlogin .status');

                $status.show().text($status.data('loading'));

				var checked = '';
				if($('form.ajaxlogin #rememberme-modal').is(':checked')){
					checked = $('form.ajaxlogin #rememberme-modal').val();
				}

				$.ajax({
					type: 'POST',
					dataType: 'json',
					url: ghostpress_params.ajax_url,
					data: {
						'action': 'ajaxlogin', //calls wp_ajax_nopriv_ajaxlogin
						'username': $('form.ajaxlogin #username-modal').val(),
						'password': $('form.ajaxlogin #password-modal').val(),
						'security': $('form.ajaxlogin #woocommerce-login-nonce-modal').val(),
						'rememberme': checked,
					},
					success: function(data){
						$('form.ajaxlogin .status').text(data.message);
						window.dataLayer = window.dataLayer || []
						window.dataLayer.push(data.dataLayer)
						if (data.loggedin === true){
							document.location.reload();
						}
					}
				});
			});

			// Duplicate handler for login page
			$('form.pagelogin').on('submit', function(e){
				e.preventDefault();

                let $status = $('form.ajaxlogin .status');

                $status.show().text($status.data('loading'));

				var checked = '';
				if($('form.pagelogin #rememberme-page').is(':checked')){
					checked = $('form.pagelogin #rememberme-page').val();
				}

				$.ajax({
					type: 'POST',
					dataType: 'json',
					url: ghostpress_params.ajax_url,
					data: {
						'action': 'ajaxlogin', //calls wp_ajax_nopriv_ajaxlogin
						'username': $('form.pagelogin #username-page').val(),
						'password': $('form.pagelogin #password-page').val(),
						'security': $('form.pagelogin #woocommerce-login-nonce-page').val(),
						'rememberme': checked,
					},
					success: function(data){
						$('form.pagelogin .status').text(data.message);
						window.dataLayer = window.dataLayer || []
						window.dataLayer.push(data.dataLayer)
						if (data.loggedin === true){
							document.location.reload();
						}
					}
				});
			});

		}
		ajax_login()

	})(jQuery);
}